import React, { Suspense } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Navbar from './Navbar';
import Footer from './Footer';
import { PageTransition } from '@/components/design-system';
import { Toaster } from '@/components/ui/sonner';

const Layout: React.FC = () => {
  const location = useLocation();

  const isLandingPage = location.pathname === '/';
  const needsHeaderOffset = !isLandingPage;

  return (
    <div className="min-h-screen flex flex-col bg-background text-foreground font-sans">
      {/* Modern unified navbar for all pages */}
      <Navbar />

      <main className={`flex-grow ${needsHeaderOffset ? 'pt-20 sm:pt-24' : ''}`}>
        <PageTransition key={location.pathname}>
          <Suspense fallback={null}>
            <Outlet />
          </Suspense>
        </PageTransition>
      </main>

      {/* Footer - excluded from dashboard pages */}
      {isLandingPage && <Footer />}

      <Toaster position="top-center" richColors />
    </div>
  );
};

export default Layout;
